/** Discriminator values for member types across users and groups. */
export const MemberType = {
  User: 'user',
  Group: 'group',
} as const;

export type MemberType = (typeof MemberType)[keyof typeof MemberType];

/** Display mode for the assignee permission options dropdown. */
export const AssigneePermissionMode = {
  Permissions: 'permissions',
  RemoveOnly: 'remove-only',
  Readonly: 'readonly',
} as const;

export type AssigneePermissionMode =
  (typeof AssigneePermissionMode)[keyof typeof AssigneePermissionMode];

/** Search mode for the assignee dropdown. */
export const SearchMode = {
  Users: 'users',
  SpaceAssignees: 'space-assignees',
  FolderAssignees: 'folder-assignees',
  TableAssignees: 'table-assignees',
} as const;

export type SearchMode = (typeof SearchMode)[keyof typeof SearchMode];

/** Unified member item for both users and groups in assignee dropdown. */
export interface UnifiedMember {
  id: number;
  name: string;
  email: string;
  member_type: 'user' | 'group';
  members_count?: number;
  is_selected: boolean;
}
